import { render, staticRenderFns } from "./FooterNew1.vue?vue&type=template&id=27c5c258&scoped=true&"
import script from "./FooterNew1.vue?vue&type=script&lang=js&"
export * from "./FooterNew1.vue?vue&type=script&lang=js&"
import style0 from "./FooterNew1.vue?vue&type=style&index=0&id=27c5c258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c5c258",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFooter,VIcon,VImg,VRow})
